// Qui célèbre et avec quels mots : déplacé dans le moteur de l'activité, que l'ancien écran de fin
// et le nouveau lisent tous les deux.
export {
    getCelebrationMessage,
    getChampion,
    getIsFastCombo,
} from "../../../engine/activity/celebration/celebration"

// Passe à l'écran de fin d'une activité rendue, et lui dit par quoi enchaîner :
// les activités à faire du moment, sans celle qui vient d'être rendue. Un
// appelant qui a son propre écran de fin (la session Sam) le reçoit à la place.
export const showActivityCongrats = (
    { user, putCongrats, putNextScreenParams, navigation, onCompletionScreen },
    congrats
) => {
    if (onCompletionScreen) {
        onCompletionScreen(congrats)
        return
    }

    const finishedId = congrats?.congratsData?.activity?.id

    putCongrats([congrats])
    putNextScreenParams({
        todoActivities: user?.todo_activities?.filter(
            (todo) => todo?.id !== finishedId
        ),
        autoSelectNext: true,
    })
    navigation.push("congrats")
}
